import axios from "axios";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  CheckCircle,
  Envelope,
  Eye,
  EyeSlash,
  XCircle,
} from "react-bootstrap-icons";

import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./VerifyClientEmailPage.css";

export default function VerifyClientEmailPage() {
  const { slug } = useParams();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [err, setErr] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const cleanEmail = email.trim().toLowerCase();

  const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(cleanEmail);
  const passwordIsValid = password.length >= 6;
  const passwordsMatch = password && confirm && password === confirm;

  const showEmailError = validated && !emailIsValid;
  const showPasswordError = validated && !passwordIsValid;
  const showConfirmError = validated && !passwordsMatch;

  const submit = async (e) => {
    e.preventDefault();
    setValidated(true);
    setErr("");

    if (!emailIsValid || !passwordIsValid || !passwordsMatch) {
      return;
    }

    try {
      setIsLoading(true);

      const verifyClient = {
        email: cleanEmail,
        password,
      };

      await axios.post(
        `${ApiConnectionString}/api/verifyAccount/${slug}`,
        verifyClient,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setComplete(true);
    } catch (error) {
      console.error(error);

      const message = error.response?.data;

      if (message === "Allready Verfied") {
        setErr("This email address has already been verified.");
      } else if (typeof message === "string") {
        setErr(message);
      } else {
        setErr(
          "We could not verify this email address. Please check it is correct."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="client-verify-loading">
        <LoadingSpinner />
      </div>
    );
  }

  if (complete) {
    return (
      <div className="client-verify-page">
        <div className="client-verify-card">
          <div className="client-verify-success-icon">
            <CheckCircle />
          </div>

          <h1>Account verified</h1>

          <p>
            Your email has been verified and your password has been created.
            You can now log in to your client portal.
          </p>

          <Link to={`/${slug}/login`} className="client-verify-btn">
            Go to login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="client-verify-page">
      <div className="client-verify-card">
        <div className="client-verify-icon">
          <Envelope />
        </div>

        <h1>Create your client login</h1>

        <p>
          Verify your email address and create a password for your client
          portal.
        </p>

        {err && (
          <div className="client-verify-error">
            <XCircle />
            <span>{err}</span>
          </div>
        )}

        <form onSubmit={submit} noValidate>
          <div className="client-verify-field">
            <label>Email address</label>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className={showEmailError ? "input-error" : ""}
            />

            {showEmailError && (
              <div className="client-verify-feedback">
                Enter a valid email address
              </div>
            )}
          </div>

          <div className="client-verify-field">
            <label>Create password</label>

            <div className="client-password-wrap">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 6 characters"
                className={showPasswordError ? "input-error" : ""}
              />

              <button
                type="button"
                onClick={() => setShowPassword((x) => !x)}
              >
                {showPassword ? <EyeSlash /> : <Eye />}
              </button>
            </div>

            {showPasswordError && (
              <div className="client-verify-feedback">
                Password must be at least 6 characters
              </div>
            )}
          </div>

          <div className="client-verify-field">
            <label>Confirm password</label>

            <div className="client-password-wrap">
              <input
                type={showConfirm ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirm your password"
                className={showConfirmError ? "input-error" : ""}
              />

              <button
                type="button"
                onClick={() => setShowConfirm((x) => !x)}
              >
                {showConfirm ? <EyeSlash /> : <Eye />}
              </button>
            </div>

            {showConfirmError && (
              <div className="client-verify-feedback">
                Passwords must match
              </div>
            )}
          </div>

          <button type="submit" className="client-verify-btn">
            Verify and create password
          </button>
        </form>
      </div>
    </div>
  );
}